import React from 'react';
import { Box } from '@mui/material';
import { IconName } from '@fortawesome/fontawesome-svg-core';
import { FaOptionIcon } from '@europrocurement/l2d-icons';

export type TimelineHaloWithDotProps = {
    haloColor: string;
    dotColor: string;
    /** Color of the optional icon inside the dot (typically palette.background.paper) */
    iconColor: string;
    icon?: IconName;
    haloSize: number;
    dotSize: number;
};

/**
 * Circular halo ring with an inner filled dot and an optional icon.
 * All colors and sizes are received as props so this component stays
 * purely presentational — no theme access needed.
 */
const TimelineHaloWithDot: React.FunctionComponent<TimelineHaloWithDotProps> = function ({
    haloColor,
    dotColor,
    iconColor,
    icon,
    haloSize,
    dotSize,
}) {
    return (
        <Box
            data-testid="timeline-halo"
            sx={{
                width: `${haloSize}px`,
                height: `${haloSize}px`,
                borderRadius: '50%',
                flexShrink: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: haloColor,
            }}
        >
            <Box
                data-testid="timeline-dot"
                sx={{
                    width: `${dotSize}px`,
                    height: `${dotSize}px`,
                    borderRadius: '50%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: dotColor,
                }}
            >
                {icon && (
                    <FaOptionIcon
                        icon={['fasdl', icon]}
                        sx={{
                            fontWeight: '500',
                            fontSize: '6px',
                            lineHeight: '14.4px',
                            color: iconColor,
                        }}
                    />
                )}
            </Box>
        </Box>
    );
};

export default TimelineHaloWithDot;
